import * as types from './actionTypes';
import { api } from './api';

export function vehicleLookup(vin, year, make, model, versionId) {
	const params = new URLSearchParams();
	params.set('vin', vin);
	params.set('year', year);
	params.set('make', make);
	params.set('model', model);
	params.set('versionId', versionId)

	return api({
		types: [types.VEHICLE__LOOKUP_REQUEST, types.VEHICLE__LOOKUP_SUCCESS, types.VEHICLE__LOOKUP_FAILURE],
		uri: `/api/vehicle?${params.toString()}`,
		shouldCallAPI: () => true,
		config: {
			method: 'get',
			headers: {
				Accept: 'application/json',
			},
		},
	});
}
